module.exports = __webpack_public_path__ + "static/media/to-top.c9368ebd.svg";